import React, { useState } from "react";
import styles from "../faq/faq.module.css"; 
import { CollapsedIcon, Pluse } from "../../../Svg";
import CustomSeparator from "../../components/maincomps/breadcrumbs/Breadcrumbs";
import breadcrumbStyle from "../../components/maincomps/breadcrumbs/breadcrumbs.module.css"

const faqData = {
    "Topic 1": [
        {
            question: "Privacy Policy",
            answer:
                "We understand that your privacy is important to you, and we are committed to protecting your personal information. We will never sell your information to any third party.",
        },
        {
            question: "What information do we collect from you?",
            answer:
                "We will only have information about you if you choose to provide it willingly. The information you provide is referred to as personal information. Please ensure that you update your personal information if any of your details change. This may include your name, email address, delivery address, and telephone number.",
        },
        {
            question: "How will we use it?",
            answer: "We will use your personal information solely to fulfill your orders and to communicate with you when necessary.",
        },
        {
            question: "Will we share your personal information with anyone else?",
            answer:
                "We will never release your personal details to any external company for mailing or marketing purposes. Payments on the website are processed by a third-party provider, which adheres to the privacy policy outlined here. We have a non-disclosure agreement in place with this provider, and they are certified by all major card issuers to store your details securely.",
        },
        {
            question: "How long will we keep your information?",
            answer:
                "We will retain your personal information only for as long as necessary and in accordance with the purpose for which you provided it. Unless it is needed to respond to a query or fulfill an order, we will delete your personal information upon your request.",
        },
        {
            question: "What are ‘cookies’ and how do we use them?",
            answer:
                "When you place an order on our website and enter your name and details, you become a recognized user, and we send a cookie to your computer. A cookie is a small file that may be placed on your computer’s hard drive for record-keeping purposes. Cookies do not contain any information that personally identifies you. They help us recognize you when you return to the website and use our services, allowing us to tailor your experience to your needs. By using cookies, we can make your online experience more efficient. For example, cookies allow you to keep selected items in your shopping basket between visits and speed up the checkout process.",
        },

    ],

};

const PrivacyPolicy = () => {
    const [selectedTopic, setSelectedTopic] = useState("Topic 1");
    const [expandedIndex, setExpandedIndex] = useState(null);

    const handleTopicClick = (topic) => {
        setSelectedTopic(topic);
        setExpandedIndex(null);
    };

    const handleToggle = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    return (
        <>
            <div className={breadcrumbStyle.breadcrumbStyle}>
                <CustomSeparator home="Home" type="Privacy Policy" />
            </div>

            <div className={styles.container}>

                <h2>Privacy Policy</h2>

                <div className={styles.content}>
                    {faqData[selectedTopic].map((item, index) => (
                        <div key={index} className={styles.faqItem}>
                            <div className={styles.question} onClick={() => handleToggle(index)}>
                                {item.question}
                                <span>{expandedIndex === index ? <div><CollapsedIcon /></div> : <div className={styles.positive}><Pluse /></div>}</span>
                            </div>
                            {expandedIndex === index &&
                                <div className={styles.answer}>{item.answer}

                                </div>
                            }
                        </div>
                    ))}
                    <div className={styles.noteTextStyle}>
                        Note: If you have any questions about this Privacy Policy, please feel free to write us at pavithrajewels916@gmail.com
                    </div>
                </div>

                <div className={styles.mobile_contant}>
                    {Object.keys(faqData).map((topic) => (
                        <div className={styles.content1}>
                            {/* <h2 className={styles.heading}>{topic}</h2> */}
                            {faqData[topic].map((item, index) => (
                                <div key={index} className={styles.faqItem}>
                                    <div
                                        className={styles.question}
                                        onClick={() => handleToggle(index)}
                                    >
                                        {item.question}
                                        <span>
                                            {expandedIndex === index ? (
                                                <div className={styles.nagative}>-</div>
                                            ) : (
                                                <div className={styles.positive}>+</div>
                                            )}
                                        </span>
                                    </div>
                                    {expandedIndex === index && (
                                        <div className={styles.answer}>
                                            {item.answer}
                                        </div>
                                    )}
                                </div>
                            ))}
                            <div className={styles.noteTextStyle}>
                                Note: If you have any questions about this Privacy Policy, please feel free to write us at pavithrajewels916@gmail.com
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default PrivacyPolicy;
